import React from 'react';
import TableHeaderCell from './TableHeaderCell';
import { ITableHeaderProps } from './Interfaces';

const TableHeader: React.FC<ITableHeaderProps> = ({ tableName, colInfos, colUserSettings, colResizeActiveIndex, onHoverGetIndex, onChangeSort, onChangeFilter, hideShowFilter, onCheckboxButtonClicked, resizable }) => {

    if (colUserSettings.length !== colInfos.length)
        return <></>

    let tableCells = colInfos.map(function (colInfo, colIndex) {
        return (
            <TableHeaderCell
                colResize={resizable}
                colResizeActiveIndex={colResizeActiveIndex}
                onHoverGetIndex={onHoverGetIndex}
                tableName={tableName}
                colInfo={colInfo}
                colUserSettings={colUserSettings[colIndex]}
                colIndex={colIndex}
                onChangeSort={onChangeSort}
                onChangeFilter={onChangeFilter}
                hideShowFilter={hideShowFilter}
                onCheckboxButtonClicked={onCheckboxButtonClicked}
                key={`${colIndex}_${colInfo.title}`} />
        );
    });

    return (<thead className="plm-datatable-thead"><tr>{tableCells}</tr></thead>);
}
export default TableHeader;